import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';


/**
 * Footer component with navigation links and contact information.
 *
 * @returns The footer component.
 */
export const Footer: React.FC = () => {
  return (
    <footer className="bg-obsidian border-t border-white/5 pt-16 md:pt-24 pb-12 text-gray-300">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          <div className="col-span-1 md:col-span-2">
            <h2 className="text-2xl font-display mb-6 text-white">Let's build something permanent.</h2>
            <Link to="/contact" className="inline-flex items-center text-lg hover:text-white transition-colors border-b border-gray-600 pb-1 hover:border-white">
              Work with Us <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-500 mb-6">Sitemap</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/work" className="hover:text-white transition-colors">Work</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/studio" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-500 mb-6">Locations</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/locations/london" className="hover:text-white transition-colors">London, UK</Link></li>
              <li><Link to="/locations/cyprus" className="hover:text-white transition-colors">Cyprus (Island-wide)</Link></li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-end border-t border-white/5 pt-8 text-xs text-gray-500 uppercase tracking-widest">
          <div>
            © {new Date().getFullYear()} <span><span className="font-bold">KIVO</span>SYSTEMS</span>.
          </div>
          <div className="mt-4 md:mt-0 flex items-center gap-3">
            <div className="flex items-center gap-3 px-4 py-2 border border-white/5 bg-white/5 rounded-full backdrop-blur-sm">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]"></span>
              </span>
              <span className="text-[10px] text-gray-400 font-bold uppercase tracking-[0.2em]">System Status: Nominal</span>
            </div>
            <Link
              to="/studio"
              className="inline-flex items-center px-4 py-2 rounded-full border border-white/10 bg-white/5 text-[10px] font-bold tracking-[0.2em] text-gray-400 hover:text-white hover:border-white/30 transition-colors"
            >
              About Us
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
